import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=c5341456&"
import script from "./Teams.vue?vue&type=script&lang=js&"
export * from "./Teams.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c5341456')) {
      api.createRecord('c5341456', component.options)
    } else {
      api.reload('c5341456', component.options)
    }
    module.hot.accept("./Teams.vue?vue&type=template&id=c5341456&", function () {
      api.rerender('c5341456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/accessmanagement/Teams.vue"
export default component.exports